"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureType = exports.ErrorType = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType[UserType["None"] = 0] = "None";
    UserType[UserType["Doctor"] = 1] = "Doctor";
    UserType[UserType["Nurse"] = 2] = "Nurse";
    UserType[UserType["Admin"] = 3] = "Admin";
    UserType[UserType["Patient"] = 4] = "Patient";
    UserType[UserType["Root"] = 99] = "Root";
})(UserType = exports.UserType || (exports.UserType = {}));
;
var ErrorType;
(function (ErrorType) {
    ErrorType["Exists"] = "exists";
    ErrorType["Unknown"] = "unknown";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var MeasureType;
(function (MeasureType) {
    MeasureType["Raw"] = "raw";
    MeasureType["Computed"] = "computed";
})(MeasureType = exports.MeasureType || (exports.MeasureType = {}));
